export const CLS_MITIGATION_SETTINGS = {
    MINIMUM_HEIGHT_OF_CTA: '228px',
    MAX_WIDTH_OF_CTA: '542px',
    MAC_WIDTH_OF_CONTENT: '1140px',
    CALLBACK_SCHEDULER_WIDTH: '1140px',
} as const;

export const GLOBAL_DESIGN_CONSTANTS = {
    ONE_COLUMN_BREAKPOINT: '650px',
    XXL: '1440px',
    LG: '1280px',
    STOP_TABLET_PADDING_BREAKPOINT: '480',
    TABLET_PAGE_PADDING: '24px',
    SMALLEST_SUPPORTED_DEVICE_WIDTH: '320px',
    TOP_NAV_HEIGHT: '80px',
    FOOTER_HEIGHT_XL: '427px',
    FOOTER_HEIGHT_LG: '423px',
    ONE_COLUMN_IMAGE_SIZE: '216',
};

export const Z_LAYERS = {
    ALWAYS_ON_TOP: 100,
    MODAL: 10000000,
};
